import React from 'react';
import BugHuntGame from './BugHuntGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <BugHuntGame />
    </div>
  );
}

export default App;
